export default {
  aggregates: {
    aggregated: 'Aggregerede resultater',
    aggregatedDate: '{startDate} - {fromDate}',
    ago: 'siden',
    from: 'fra',
    since: 'siden',
    unit: {
      DAY: 'dag | dage',
      MONTH: 'måned | måneder',
      YEAR: 'år | år'
    },
    untilNow: 'indtil nu'
  },
  categoryDetails: {
    average: 'Gennemsnit:',
    chartLabel: {
      noLabel: 'Nej',
      yesLabel: 'Ja'
    },
    description:
      'Dette viser, hvordan teamets svar på alle spørgsmål i kategorien er fordelt.',
    hideOwnAnswers: 'Skjul egne svar',
    noResponses: 'Ingen svar',
    notParticipating: 'Du har ikke selv svaret på disse spørgsmål.',
    numberOfPeople: 'Respondenter:',
    sensitiveQuestion: 'Kun synlig for dig som manager.',
    showFollowUpQuestions: 'Vis opfølgende spørgsmål',
    toggleButton: {
      overview: 'Oversigt',
      questions: 'Spørgsmål'
    },
    tooltip: {
      barValue: 'ingen | {count} person | {count} personer',
      barValueAnswers: 'ingen | {count} svar | {count} svar'
    },
    workWith: 'Forbedre {categoryName}',
    yourResponse: 'Du svarede:'
  },
  error: {
    couldNotLoadAggregates: 'Kunne ikke indlæse aggregerede resultater.',
    couldNotLoadResults: 'Kunne ikke indlæse resultater.',
    networkError:
      'Der opstod et problem med at indlæse data fra internettet. Har du en fungerende forbindelse?',
    unknown: 'Der er en ukendt fejl'
  },
  errors: {
    status: {
      BadRequest: 'Forkert anmodning til server.',
      Forbidden: 'Det er ikke tilladt at tilgå denne ressource.',
      InternalServerError:
        'Noget gik galt på serveren, kontakt support, hvis dette vedvarer',
      NotFound: 'Kunne ikke finde, hvad du leder efter',
      Unauthorized: 'Du har ikke rettigheder til at tilgå denne ressource.',
      UnknownError: 'Der opstod en ukendt fejl'
    }
  },
  freetext: {
    loadResponses: 'Indlæs svar',
    noFreeTextQuestions:
      'Når din undersøgelse indeholder spørgsmål i fri tekst, vil du kunne se alle svarene hér.',
    notEnoughResponses: 'Ikke nok svar.',
    responses: 'Ingen svar responses|{count} svar | {count} svar'
  },
  general: {
    add: 'Tilføj',
    cancel: 'Annullér',
    entireOrganization: 'Hele organisationen',
    ok: 'Ok'
  },
  groupsComparison: {
    averageForItem:
      '{value} er den gennemsnitlige værdi for spørgsmål inden for {title}. {compareToBenchmark}',
    currentValue: 'Nuværende værdi',
    filter: {
      findGroups: 'Find grupper',
      shouldExportWithHierarchy: 'Inkluderer underliggende grupper'
    },
    loadMore: 'Indlæs flere',
    loadMoreInGroup: 'Indlæs mere under {groupName}',
    noone: 'Ingen har svaret',
    noResults:
      'Ikke nok svar for denne gruppe endnu. {numberOfUsersThatHaveRespondedText}.',
    noResultsResponded: 'har svaret',
    nps: 'Netto promoter-score',
    nps_detractors: 'Modtalere',
    nps_passives: 'Passive',
    nps_promoters: 'Promotere',
    questions: 'Spørgsmål i kategori',
    showTrend: 'Vis ændring',
    violationsIn:
      'Der er rapporteret om overtrædelser inden for {groupName}. Kontakt HR-afdelingen, som kan fortælle dig mere og hjælpe dig med at løse problemet fremadrettet.'
  },
  history: {
    selectorDescriptions: {
      noCustomDateSelected: 'Vælg en dato som starttidspunkt for historikken.',
      selectDate: 'Ville vise historik for undersøgelser siden {date}.',
      selectedDate: 'Viser historik for undersøgelser siden {date}.'
    },
    selectorOptions: {
      custom: 'tilpasset',
      oneMonth: '1 m',
      oneYear: '12 m',
      sixMonths: '6 m'
    }
  },
  loading: {
    error: {
      link: 'Prøv igen'
    }
  },
  navbar: {
    administration: 'Admin',
    currentSurveys: 'Nuværende undersøgelser',
    help: 'Hjælp',
    myActivities: 'Handlinger',
    ourResults: 'Resultater',
    overview: 'Oversigt',
    team: 'Team',
    welcome: 'Velkommen'
  },
  page: {
    results: 'Alle resultater'
  },
  resultDetails: {
    backToResults: 'Gå tilbage',
    exportData: 'Eksporter',
    exportModal: {
      includeSensitiveQuestions: 'Inkluderer følsomme spørgsmål',
      loadingMessage: 'Forbereder data til eksport, vent et øjeblik!',
      saveAsExcelAllGroupsDescription:
        'Når du eksporterer til Excel, får du en fil med resultater for {groupTitle} og alle underliggende grupper. Dette er nyttigt, hvis du ønsker at foretage din egen analyse eller beregninger af flere grupper.',
      saveAsExcelButton: 'Excel',
      saveAsExcelDescription:
        'Når du eksporterer til Excel, får du en fil med resultater for {groupTitle}{segmentInfo}. Dette er nyttigt, hvis du ønsker at foretage din egen analyse eller beregninger.',
      saveAsPdfButton: 'PDF',
      saveAsPdfDescription:
        'Du får et PDF-dokument med resultater for alle kategorier og spørgsmål for den udvalgte gruppe. Nyttigt, hvis du ønsker at udskrive resultaterne.',
      saveAsPowerPointButton: 'Powerpoint',
      saveAsPowerPointDescription:
        'En PowerPoint-eksport leverer en pæn præsentation med resultater for {groupTitle}{segmentInfo}. Perfekt, hvis du har behov for at vise resultaterne til andre på en storskærm.'
    },
    notes: {
      draggable: {
        explanation: 'Kun synlig for dig',
        placeholder:
          'Skriv dine egne noter, kommentarer og refleksioner om undersøgelsen her',
        title: 'Personlige noter'
      },
      status: {
        initial: 'Gemmer automatisk, mens du skriver',
        saved: 'Ændringer gemt!',
        unsaved: 'Gemmer snart...'
      }
    },
    tagDetails: {
      color: {
        alerts: {
          notEnoughResponses:
            'Der er ikke nok svar til at vise resultater pr. bruger'
        },
        description: {
          high: 'Der er én person, der svarede, så deres gennemsnitlige score blev grøn.|Der er {count} personer, der svarede, så deres gennemsnitlige score blev grøn.',
          low: 'Der er én person der svarede, så deres gennemsnitlige score blev rød.|Der er {count} personer, der svarede, så deres gennemsnitlige score blev rød.',
          medium:
            'Der er én person, der svarede, så deres gennemsnitlige score blev gul.|Der er {count} personer, der svarede, så deres gennemsnitlige score blev gul.'
        },
        title: 'Ingen|En person|{count} personer'
      },
      currentValue: {
        equalsToBenchmarkValue:
          'Din score er den samme som Pulsᐩ benchmark® for {title}.',
        higherThanBenchmarkValue:
          'Din score er {benchmarkDiff} højere end Pulsᐩ benchmark® for {title} som er {benchmarkValue}. Flot!',
        lowerThanBenchmarkValue:
          'Din score er {benchmarkDiff} lavere end Pulsᐩ benchmark® for {title} som er {benchmarkValue}.',
        percentagePoints: 'procentpoint'
      },
      enps: {
        button: {
          description:
            'Du sendes videre til vores partner, EQI, der indsamler data til benchmarking for en lang række organisationer og giver dig detaljede oplysninger om din egen eNPS score.',
          title: 'Sammenlign din eNPS score med andre organisationer'
        }
      },
      toggleButton: {
        history: 'Historik',
        overview: 'Oversigt'
      }
    }
  },
  results: {
    aggregated: 'Samlet',
    chooseSurvey: 'Vælg undersøgelse',
    finished: 'Færdig',
    published: 'Igangværende'
  },
  resultsmessages: {
    disclaimer: 'Pulsᐩ AI bruger generativ AI og kan begå fejl.',

    error: {
      generic:
        'Åh nej,... der er noget, der ikke fungerer som forventet. Prøv at indlæse siden igen.',
      notEnoughResults:
        'Ingen resultater at tale om. Vælg en anden gruppe eller undersøgelse for at bruge Pulsᐩ AI.'
    },
    moreInfo: 'Lær, hvordan du anvender Pulsᐩ AI som leder',
    moreInfoLink: 'https://www.puls-solutions.com/help/#/section/1/articles/10',
    placeholder: 'Stil et spørgsmål om resultater...',
    reload: 'Genindlæs side',
    report: 'Rapportér problem',
    send: 'Send',
    suggestionHeader: 'Hér er der nogle forslag til spørgsmål, du kan stille:',
    suggestions: {
      groupsComparison: {
        1: 'Hvilke grupper skal jeg fokusere på?',
        2: 'Er der et spørgsmål, som de fleste grupper bør arbejde på?',
        3: 'Hvilke grupper viser negative tendenser?',
        4: 'Hvilke grupper har positive tendenser?',
        5: 'Hvilke grupper skiller sig negativt ud?',
        6: 'Hvilke grupper har brug for min opmærksomhed?',
        7: 'Hvad skal jeg gøre først?'
      },
      overview: {
        1: 'Hvad skal jeg gøre med vores resultat?',
        2: 'Hvordan skal jeg præsentere dette for mit team?',
        3: 'Samlet set, hvordan ser resultaterne ud?',
        4: 'Hvad er de top 3 handlinger, vi skal tage?',
        5: 'Hvad kan jeg forbedre i min ledelse?',
        6: 'Hvilke risici har vi?',
        7: 'Hvad kan der ske, hvis vi ikke handler?',
        8: 'Hvad skal jeg prioritere?',
        9: 'Hvad er prognosen for mit team?'
      }
    },
    title: 'Pulsᐩ AI'
  },
  resultsPerAttribute: {
    attributes: {
      all: {
        title: 'alle sammen'
      }
    }
  },
  sections: {
    resultsForSurvey: {
      tabs: {
        compare: {
          title: 'Sammenlign'
        },
        export: {
          title: 'Eksportér'
        },
        freetext: {
          title: 'Fri tekst'
        },
        results: {
          title: 'Resultater af undersøgelse'
        }
      }
    }
  },
  segmentedDetails: {
    notEnoughResponses:
      'Ikke muligt at vise statistik uden at risikere at miste anonymitet.',
    others: 'Andet | Andre',
    tooltip: {
      barValue: '{numberOfPeople} {segment}'
    }
  },
  sidebar: {
    administration: 'Administration',
    currentSurveys: 'Nuværende spørgeundersøgelser',
    dashboard: 'Dashboard',
    help: 'Hjælp',
    logOut: 'Log ud',
    myActivities: 'Mine handlinger',
    ourResults: 'Vores resultater'
  },
  topbanner: {
    preview: {
      body: 'Du kigger nu på den nye version af Pulsᐩ resultatvisning, der byder på mange forbedringer! Kontakt os, hvis du oplever noget, der ikke fungerer, som det skal, eller hvis du har feedback! Du kan også gå tilbage til den gamle version, hvis du vil.',
      header: 'Ny version!'
    }
  },
  trendArrow: {
    category: {
      tooltip: {
        trend_decreased:
          'I perioden {startDate} - {endDate} er resultatet faldet for {categoryName}.',
        trend_increased:
          'I perioden {startDate} - {endDate} er resultatet steget for {categoryName}. Fortsæt det gode arbejde!',
        trend_same:
          'Resultatet er forblevet det samme for {categoryName} i tidsperioden {startDate} - {endDate}.'
      }
    },
    noTrend: 'Der er ingen ældre spørgeundersøgelse at sammenligne med.',
    tag: {
      tooltip: {
        nps_trend_decreased:
          'Sammenlignet med tidligere spørgeundersøgelser den {oldSurveyDate} er resultatet gået {changeInPercent}% ned for {tagName}.',
        nps_trend_increased:
          'Sammenlignet med tidligere spørgeundersøgelser den {oldSurveyDate} er resultatet gået {changeInPercent}% op for {tagName}.',
        nps_trend_same:
          'Resultatet er nogenlunde det samme ({changeInPercent}% change) for {tagName} siden sidste spørgeundersøgelse den {oldSurveyDate}.',
        trend_decreased:
          'I perioden {startDate} - {endDate} er resultatet faldet for {tagName}.',
        trend_increased:
          'I perioden {startDate} - {endDate} er resultatet steget for {tagName}',
        trend_same:
          'Resultatet er forblevet det samme for {categoryName} i tidsperioden {startDate} - {endDate}.'
      }
    }
  },
  utilityBar: {
    allGroups: 'Alle grupper',
    cannotChangeGroupsWhileComparing:
      'Når du befinder dig i sammenligningsvisning, ser du flere grupper samtidig.',
    group: 'Gruppe',
    segment: 'Segment',
    survey: 'Undersøgelse'
  },
  widgetActionsSummary: {
    labels: {
      peopleThatSelectedAnAction:
        'Antal personer, der valgte mindst en handling',
      totalActions: 'Samlet antal valgte handlinger'
    },
    title: 'Opsummering af handlinger'
  },
  widgetAlert: {
    actions: {
      saved: 'Tak, aktiviteten blev gemt.'
    },
    links: {
      tooltip: 'Links åbner i et nyt vindue'
    },
    notEnoughData: 'Der er ikke noget at vise her lige nu.'
  },
  widgetCategoriesBars: {
    aggregateInfo: {
      harassment: {
        info: 'Sidst rapporteret {surveyDate}.'
      },
      question: {
        info: 'Sidst spurgt {surveyDate} i "{surveyTitle}".'
      }
    },
    notEnoughResponses: 'Der er endnu ikke svar nok til at vise noget her.',
    title: 'Kategorier',
    tooltip: {
      value:
        'Dette er gennemsnitsværdien for alle svar på spørgsmål inden for  {categoryName} besvaret af folk i {groupName}.'
    }
  },
  widgetErrorFallback: {
    description:
      'Der opstod en uventet fejl ved forsøg på indlæsning af widget. Prøv først at genindlæse siden. Hvis problemet vedvarer, bedes du underrette os om problemet, så kigger vi på det med det samme!',
    hideErrorDetails: 'Skjul detaljer om fejl',
    showErrorDetails: 'Vis detaljer om fejl',
    title: 'Problem i widget!'
  },
  widgetGroupActions: {
    allCategories: 'I alle kategorier',
    freeText: {
      alert: {
        noResults: 'Intet fundet. Prøv at skrive noget andet.',
        typeMore: 'Skriv noget mere'
      },
      filterField: {
        placeholder: 'Skriv for at finde kommentarer'
      },
      numberOfComments: '{numberOfComments} kommentarer'
    },
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887258169',
        title: 'Sådan udvikler du eget ansvar hos medarbejderne'
      }
    },
    noActions: 'Ingen handlinger at vise.',
    noActionsSelectedInCategory: 'Der er ingen handlinger valgt',
    otherActions: 'Egne handlinger',
    people: 'ingen | {count} person | {count} personer',
    peopleSelectedActions:
      'Ud af {peopleResponded} personer, der svarede har kun 1 valgt mindst én handling ({percentage}%)| Ud af {peopleResponded} personer der svarede, valgte {count} personer mindst én handling ({percentage}%)',
    title: 'Valgte handlinger for personer i {groupName}',
    tooltip: {
      numberOfPeopleChoseActions:
        '1 person valgte denne handling| {count} personer valgte denne handling'
    }
  },
  widgetGroupPriorities: {
    description:
      'Disse områder er ifølge undersøgelsens deltagere de vigtigste at fokusere på lige nu.',
    freeTextResponses: 'Vis fritekstsvar',
    links: {
      guide: {
        link: 'https://player.vimeo.com/video/887214144',
        title: 'Sådan udvikler du dit team med Pulsᐩ'
      }
    },
    noPriorities: 'Der er ikke valgt nogen prioriteter af deltagerne.',
    people: 'ingen | {count} person | {count} personer',
    thinkImportant: ' synes "{category}" er vigtigst',
    title: 'Prioriteter for personer i {groupName}'
  },
  widgetNotImplemented: {
    content: 'Ikke implementeret endnu'
  },
  widgetSurveyInfo: {
    endDate: 'Slutdato:',
    noone: 'Ingen har svaret',
    notEnoughResponses: {
      aggregate:
        'Antallet af personer, der deltog i tidsrummet, var ikke tilstrækkeligt til at vise resultater.',
      completed:
        'Antallet af personer, der deltog i undersøgelsen, var ikke tilstrækkeligt til at vise resultater.',
      published:
        'Antallet af personer, der har deltaget i undersøgelsen, er stadig ikke tilstrækkeligt til at vise resultater.'
    },
    participation: {
      title: 'Deltagelse'
    },
    startDate: 'Startdato:',
    status: {
      completed: 'Undersøgelsen er afsluttet! Dette er de endelige resultater.',
      published: 'Undersøgelsen er stadig i gang. Resultaterne er foreløbige.'
    },
    usersInvited: 'Personer inviteret:',
    usersResponded: 'Folk der har svaret:'
  },
  widgetTagsDonuts: {
    description: {
      all: 'Dette er de seneste resultater for {groupName}.'
    },
    notEnoughResponses: 'Der er endnu ikke svar nok til at vise noget her.',
    title: {
      company: 'Hele {organizationName}'
    },
    tooltip: {
      enps_description:
        'eNPS står for medarbejder netto promoter-score og måler, hvor villige ansatte er til at tale for ansættelse i deres firma.',
      nps_description:
        'NPS står for Netto promoter-score og måler, hvor sandsynligt det er, at folk anbefaler noget til andre.',
      nps_detractors: 'Modtalere',
      nps_passives: 'Passive',
      nps_promoters: 'Promotere',
      value:
        'Dette er gennemsnitsværdien for alle svar til spørgsmål tagget med {tagName} besvaret af folk i {groupName}.'
    }
  },
  widgetTagsTrends: {
    title: '{tagNames} over tid',
    twoTags: '{tag1} og {tag2}'
  }
}
